/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SwedishTaxPayerType {
  K = 0,
  O = 1,
  T = 2,
  E = 3,
  A = 4,
}
